module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"default-question-context-view\">\n      <div class=\"content\" [innerHtml]=\"getContextText() | mpSafeHtml\"></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/default-question-context-view/default-question-context-view.html
// module id = TNhs
// module chunks = 3